import Vue from 'vue';
import $http from 'middleware/http';



const FILE_NAME = 'status.xml';



export default {
  namespaced: true,

  state: {
    loaded: false,
    statuses: {},
  },

  getters: {
    filepath: (state, getters, rootState, rootGetters) => rootGetters['path/$join']('conf', FILE_NAME),
    at: state => id => state.statuses[id] || {},
    displayAt: (state, getters) => (id, divider = ' ') => {
      const status = getters['at'](id);
      return status && [
        status.date,
        status.time,
        status.status,
        status.text,
      ].filter(s => !!s).join(divider);
    },
    // 「先輩からの入試直前アドバイス」用
    displayAtSenpai: (state, getters) => (id, divider = ' ') => {
      const status = getters['at'](id);
      return status && [
        status.date,
        status.time,
        status.status,
        status.text,
      ].filter(s => !!s).join(divider)
      || "準備中";
    },
    // 得点調整の非表示用
    displayAtChosei: (state, getters) => (id, divider = ' ') => {
      const status = getters['at'](id);
      return status && status.status ? {} : {display: "none"};
    },
    statuses: state => state.statuses,
    keys: (state, getters) => Object.keys(getters['statuses']),
  },

  actions: {
    async load({ commit, getters, rootGetters }) {
      const res = rootGetters['config/dontUseStatusDisplay'] ? {data: null} : await $http.get(getters['filepath'], {responseType: 'document'});
      commit('setData', res.data);
    },
    set({ commit, getters }, {id, data = {}}) {
      const nowdata = getters['at'](id);
      const newData = Object.assign({}, nowdata, data);
      commit('set', {id, data: newData});
    },
  },

  mutations: {
    set(state, {id, data}) {
      Vue.set(state.statuses, id, data);
    },
    setData(state, xml) {
      if (xml) {
        const statuses = {};
        const $xml = $(xml);

        $xml.find('item').each(function() {
          const $item = $(this),
                id    = $item.find('id').text();

          const status = {
            date  : $item.find('date').text(),
            time  : $item.find('time').text(),
            status: $item.find('status').text(),
            text  : $item.find('text').text(),
          };

          statuses[id] = status;
        });

        // ダミーデータを設定しておく
        statuses._dummy = {
          date  : '●/●',
          status: 'ダミー',
          text  : '',
          time  : 'HH:MM',
        };
        state.statuses = statuses;
      }

      state.loaded = true;
    },
  },
}


// WEBPACK FOOTER //
// ./src/js/store/modules/status.js